import axios from 'axios'

export const api = axios.create({
  baseURL: process.env.REACT_APP_BASEURL_API,
})

const token = localStorage.getItem('@seeksales:token')

if (token) api.defaults.headers.common.Authorization = `Bearer ${token}`
